import { get } from "lodash"
import COLORS from "../../theme/color"
export const colorPicker = (colorname:string) => {
  return get(COLORS, colorname, "#000");
};